import React, { useEffect, useState } from "react";
import { Button, Container, Modal, Table } from "react-bootstrap";
import { TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import notify from "../../../Notifcation";
import { ToastContainer } from "react-toastify";
import Pagination from "../../../Utility/Pagination/Pagination";
import { useTableExcelExport } from "../../../Utility/useTableExcelExport";
import {
  DeleteSalaryAction,
  GetAllSalaryAction,
} from "../../../../redux/actions/SalaryAction";
import {
  filterSalariesBySearch,
  formatArabicMonth,
} from "../../../Utility/FormPrintView/formPrintHelpers";
const Display = ({
    Datee,
  setDate,
  State,
  setState,
  jopType,
  setjopType,
  EmployeeName,
  setEmployeeName,
  jopTypeNumber,
  setjopTypeNumber,
  mainSalary,
  setmainSalary,
  kpis,
  setkpis,
  deductions,
  setdeductions,
  net,
  setnet,
  borrow,
  setborrow,
  note,
  setnote,
  isEdit,
  setIsEdit,
  Eye,
  setEye,
  SalaryId,
  setSalaryId,
  userData,
  setKey
}) => {
  const [Dateeto, setDateto] = useState("");
  const [Dateefrom, setDatefrom] = useState("");
  const [isPress, setIsPress] = useState(false);
  const [Searchkey, setSearchkey] = useState("");
  const [loading, setLoading] = useState(true);
  const PageSize = 7;
  const { tableRef, onDownload } = useTableExcelExport(
    "بيانات مرتب موظف",
    "بيانات مرتب موظف",
  );
  const [showDelete, setshowDelete] = useState(false);
  const handleCloseDelete = () => setshowDelete(false);
  const handleShoweDelete = (itemid) => {
    setshowDelete(true);
    setSalaryId(itemid);
  };
  const All = useSelector((state) => state.SalaryR.GetSalary);
  const dispatch = useDispatch();

  const buildSearchQuery = (page = 1) => {
    const query = { pageNumber: page, pageSize: PageSize };
    if (Dateefrom) query.from = Dateefrom;
    if (Dateeto) query.to = Dateeto;
    if (Searchkey.trim()) query.searchTerm = Searchkey.trim();
    return query;
  };

  const filteredSalaries = filterSalariesBySearch(All?.data, Searchkey);

  const onPress = async (page) => {
    await dispatch(GetAllSalaryAction(buildSearchQuery(page)));
  };

  const handelDeleteItem = async () => {
    setIsPress(true);
    setLoading(true);
    await dispatch(DeleteSalaryAction(SalaryId));
    setLoading(false);
    setSalaryId(null);
    setshowDelete(false);
    setIsPress(false);
  };
  const Update = (item) => {
    setKey("enter");
    setEmployeeName({
      name: item.employeeName,
      id: item.employeeId,
    });
    setDate(item.date.split("T")[0]);

    setjopType(item.jopType);
    setjopTypeNumber(item.jopTypeNumber);
    setmainSalary(item.mainSalary);
    setkpis(item.kpis);
    setdeductions(item.deductions);
    setnet(item.net);
    setborrow(item.borrow);
    setnote(item.note);
    setSalaryId(item.id);
    setIsEdit(true);
    setEye(false);
  };
  const Showw = (item) => {
    setKey("enter");
    setEmployeeName({
      name: item.employeeName,
      id: item.employeeId,
    });
    setDate(item.date.split("T")[0]);
    setjopType(item.jopType);
    setjopTypeNumber(item.jopTypeNumber);
    setmainSalary(item.mainSalary);
    setkpis(item.kpis);
    setdeductions(item.deductions);
    setnet(item.net);
    setborrow(item.borrow);
    setnote(item.note);
    setIsEdit(false);
    setEye(true);
  };

  useEffect(() => {
    dispatch(GetAllSalaryAction(buildSearchQuery()));
  }, [Dateeto, Dateefrom]);

  const handleSubmit = async () => {
    await dispatch(GetAllSalaryAction(buildSearchQuery()));
  };

  const DEL = useSelector((state) => state.SalaryR.DeleteSalary);

  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 2000);
      if (DEL) {
        if (DEL.statusCode === 200 || DEL.statusCode === 201) {
          if (
            DEL &&
            DEL.responseMessage === "Great, salary deleted Successfully"
          ) {
            dispatch(GetAllSalaryAction(buildSearchQuery()));
            notify("تم حذف البيانات بنجاح", "success");
          }
        } else if (DEL.statusCode !== 200 || DEL.statusCode !== 201) {
          notify("حدث خطأ حاول مرة اخرى", "error");
        }
      }
    }
  }, [loading]);

  return (
    <>
      <div className="enterr">
        <Container>
          <div className="inputs-container">
            <div className="inp-container">
              <div className="dateee">
                {Dateefrom ? Dateefrom.split("-").reverse().join("-") : null}
              </div>
              <i className="ty fa-solid fa-calendar-days"></i>
              <TextField
                label="التاريخ من"
                variant="outlined"
                type="date"
                value={Dateefrom}
                onChange={(e) => setDatefrom(e.target.value)}
              />
            </div>
            <div className="inp-container">
              <div className="dateee">
                {Dateeto ? Dateeto.split("-").reverse().join("-") : null}
              </div>
              <i className="ty fa-solid fa-calendar-days"></i>
              <TextField
                label="التاريخ إلى"
                variant="outlined"
                type="date"
                value={Dateeto}
                onChange={(e) => setDateto(e.target.value)}
              />
            </div>
            <div className="inp-container ">
              {" "}
              <TextField
                label="ابحث"
                variant="outlined"
                value={Searchkey}
                onChange={(e) => setSearchkey(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleSubmit();
                }}
              />
              <i
                className="ty fa-solid fa-magnifying-glass"
                onClick={handleSubmit}></i>
            </div>{" "}
            <div className="inp-container"></div>
          </div>
          <button className="buttonadd" onClick={handleSubmit}>
            بحث
          </button>
        </Container>
        <Table
          ref={tableRef}
          id="my-table"
          className="maint"
          responsive
          striped
          bordered
          hover>
          <thead>
            <tr>
              <th>
                التاريخ<i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                اسم الموظف <i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                نوع العمل <i className="fa-regular fa-calendar-check"></i>
              </th>
              <th>
                عدد<i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                الأساسي<i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                مكافات<i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                سلف<i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                خصومات<i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                صافي القيمة<i className="fa-regular fa-calendar-check"></i>
              </th>
              <th className="export-only-column">
                ملاحظات <i className="fa-regular fa-calendar-check"></i>
              </th>

              <th className="icon-w"> </th>
              <th className="icon-w"> </th>
              <th className="icon-w"> </th>
            </tr>
          </thead>
          <tbody>
            {filteredSalaries.length > 0
              ? filteredSalaries.map((item, idx) => {
                  // ForceCount = ALL.TotalPages - 1;
                  return (
                    <tr key={idx} onDoubleClick={() => Update(item)}>
                      <td>{new Date(item.date).toLocaleDateString("en-GB")}</td>
                      <td>{item.employeeName}</td>
                      <td>{item.jopType}</td>
                      <td>
                        {item.jopType === "بالشهر"
                          ? formatArabicMonth(item.jopTypeNumber)
                          : item.jopTypeNumber}
                      </td>
                      <td>{item.mainSalary}</td>
                      <td>{item.kpis}</td>
                      <td>{item.borrow}</td>
                      <td>{item.deductions}</td>
                      <td>{item.net}</td>
                      <td className="export-only-column">{item.note}</td>

                      <td className="icon-w" onClick={() => Update(item)}>
                        <i
                          className="fa fa-solid fa-pen-to-square icon-blue"
                          style={{ color: "#333" }}></i>
                      </td>
                      <td className="icon-w">
                        {" "}
                        <i
                          onClick={() => handleShoweDelete(item.id)}
                          className="fs fa-solid fa-trash-can icon-red"
                          style={{ color: "#333" }}></i>
                      </td>
                      <td className="icon-w">
                        <i
                          onClick={() => Showw(item)}
                          className="fa-solid fa-eye"
                          style={{ color: "#333" }}></i>
                      </td>
                    </tr>
                  );
                })
              : null}
          </tbody>
        </Table>
        <ToastContainer autoClose={1200} />
        <Pagination
          onPress={onPress}
          PageSize={PageSize}
          PageCount={All ? All.totalPages : null}
        />
        <button className="buttonadd" onClick={onDownload}>
          تصدير
        </button>
      </div>
      <div className="mod">
        <Modal
          show={showDelete}
          onHide={handleCloseDelete}
          backdrop="static"
          centered
          contentClassName="cont"
          keyboard={false}
          style={{ width: "100%", margin: "0px auto", textAlign: "center" }}>
          {/* <Modal.Header closeButton>
                            <Modal.Title> </Modal.Title>
                          </Modal.Header> */}
          <Modal.Body>هل تريد الحذف ؟ </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="close"
              onClick={handleCloseDelete}>
              إغلاق
            </Button>
            <Button
              variant="primary"
              className="edit"
              onClick={handelDeleteItem}>
              موافق
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};
export default Display;
